import React, {createContext, useContext, useState, useCallback} from "react";
import {isEqual, isFunction} from "lodash";
import {initialFilter} from "./CountryUIHelpers";

const CountryUIContext = createContext();

export function useCountryUIContext() {
  return useContext(CountryUIContext);
}

export const CustomersUIConsumer = CountryUIContext.Consumer;

export function CountryUIProvider({CountryUIEvents, children}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initCountry = {
   name:"",
   countryCode:""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    initCountry,
    newCountryButtonClick: CountryUIEvents.newCustomerButtonClick,
    openEditCustomerDialog: CountryUIEvents.openEditCustomerDialog,
    openDeleteCustomerDialog: CountryUIEvents.openDeleteCustomerDialog,
    openDeleteCustomersDialog: CountryUIEvents.openDeleteCustomersDialog,
    openFetchCustomersDialog: CountryUIEvents.openFetchCustomersDialog,
    openUpdateCustomersStatusDialog: CountryUIEvents.openUpdateCustomersStatusDialog
  };

  return <CountryUIContext.Provider value={value}>{children}</CountryUIContext.Provider>;
}